import script from "./userSub.vue?vue&type=script&setup=true&lang=js"
export * from "./userSub.vue?vue&type=script&setup=true&lang=js"

import "./userSub.vue?vue&type=style&index=0&id=fb084706&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb084706"]])

export default __exports__